if (!customElements.get("foundation-products")) {
  class FoundationProducts extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        slider: "[data-slider]",
      };

      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
        },
        instances: {
          slider: null,
        },
        options: {
          slider: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 32,
            loop: false,
            centeredSlides: false,
            navigation: {
              prevEl: this.querySelector(".swiper-arrow--prev"),
              nextEl: this.querySelector(".swiper-arrow--next"),
            },
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              990: {
                slidesPerView: 4,
                slidesPerGroup: 2,
              },
              1240: {
                slidesPerView: 6,
                slidesPerGroup: 3,
              },
            },
          },
        },
      };
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.settings.instances.slider = new window.Swiper(
        this.settings.elements.slider,
        this.settings.options.slider,
      );

      this.settings.instances.slider.slidePrev(0);
      this.settings.instances.slider.slideNext(0);
    }
  }

  customElements.define("foundation-products", FoundationProducts);
}
